export default "__VITE_ASSET__7881e266__"